// extracted by mini-css-extract-plugin
export default {"Badge":"kcb3qSho","Shelf":"Y5P0MFjJ","Content":"rmC65j6f","CloseButton":"BiX1d01d"};